import { render, staticRenderFns } from "./GroupAddMember.vue?vue&type=template&id=84887a7e&"
import script from "./GroupAddMember.vue?vue&type=script&lang=js&"
export * from "./GroupAddMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports